// @flow
import * as React from "react"
import sanitizeHtml from "sanitize-html"
import { Text } from "componentsStyled/Typography/Texts"

const Description = ({ description }: Props) => {
  const sanitizedHtml = sanitizeHtml(description, {
    allowedTags: [
      // Formatting
      'b', 'i', 'strong', 'em', 'strike', 'abbr', 'code', 'pre',
      // Structuring
      'p', 'div', 'hr', 'br', 'div',
      // Linking
      'a',
      // Headings
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
      // Lists
      'ul', 'ol', 'nl', 'li',
      // Tables
      'table', 'thead', 'caption', 'tbody', 'tr', 'th', 'td',
      // Notably absent: img, iframe
    ],
  })
  return (
    <React.Fragment>
      <Text dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
    </React.Fragment>
  )
}

type Props = {|
  description: string,
|}

export default Description



// WEBPACK FOOTER //
// ./src/components/Description/index.js